import { useMutation } from '@tanstack/react-query';

import { MembershipFormSchemaValues } from 'src/features/membership/formSchema';
import { Membership } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership/`;

type MutationFnType = typeof mutationFn;

interface DTO extends MembershipFormSchemaValues {
    parkingId: string;
}
const mutationFn = ({ parkingId, ...data }: DTO): Promise<Membership> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateMembership };
